module.exports = __webpack_public_path__ + "img/14.886a8fd2.svg";